import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
import { EmptyState } from "../primitives/EmptyState.js";
import { tokens } from "@wmart/design-tokens";
export function RevenueChart({ data, width = 720, height = 240, className, }) {
    if (data.length === 0) {
        return (_jsx(EmptyState, { title: "No data yet", body: "Revenue trends will appear here once you start receiving orders.", ...(className ? { className } : {}) }));
    }
    const all = data.flatMap((d) => [d.current, d.prior ?? 0]).filter((v) => v > 0);
    const max = Math.max(...all, 1);
    const stepX = width / (data.length - 1 || 1);
    const toY = (v) => height - (v / max) * (height - 24) - 12;
    const linePath = data
        .map((d, i) => `${i === 0 ? "M" : "L"}${i * stepX},${toY(d.current)}`)
        .join(" ");
    const priorPath = data.every((d) => d.prior !== undefined)
        ? data.map((d, i) => `${i === 0 ? "M" : "L"}${i * stepX},${toY(d.prior)}`).join(" ")
        : null;
    return (_jsxs("svg", { "data-slot": "revenue-chart", viewBox: `0 0 ${width} ${height}`, className: cn("h-auto w-full", className), role: "img", "aria-label": "Revenue, last 14 days vs prior period", children: [priorPath ? (_jsx("path", { d: priorPath, fill: "none", stroke: tokens.ink[300], strokeWidth: 1.25, strokeDasharray: "4 3" })) : null, _jsx("path", { d: linePath, fill: "none", stroke: tokens.accent.olive, strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}
